
<script>


export const item = 
{
    props :{
        url : String,
        title : String,
        text : String
    },
    render()
    {
        const style = "background-image : url('" + this.$props.url + ")";
        return(
            
                <li class="card_item">
        <div class="card_m">
            <div class="card_image" style={style}></div>
            <div class="card_content">
                <div class="card_title"> <b>{this.$props.title} </b></div>
                <div class="card_text">{this.$props.text}</div>
            </div>
        </div>

                </li>
        );
    }
}

export const list = 
{
    
    render() {
        return(
            <ul class="cards"  >
                {this.$slots.default} 
            </ul>
        );
    }
}

export default list
</script>

<style>
.card_item {
    display: flex;
    padding: 1rem;
}

@media(min-width: 40rem) {
        .card_item{
            width: 50%;
        }
    }

@media(min-width: 56rem) {
        .card_item{
            width: 33.3333%;

        }
  }
.card_content {
    display: flex;
    flex-direction: column;
    padding: 0.25em;
}

.cards {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding: 0;
}

.card_m {
    box-shadow: 0px 0px 8px 1px rgba(0,0,0,0.28);
    background-color: white;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
}

.card_image {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    filter: contrast(70%); 
    overflow: hidden;
    position: relative;
    transition: filter 0.5s cubic-bezier(.43,.41,.22,.91);;
}

.card_image:hover {
    filter: contrast(100%);
}

.card_image::before {
    content: "";
	display: block;
    padding-top: 56.25%;
  
}

img {
  height: auto;
  max-width: 100%;
  vertical-align: middle;
}

.card_title {
  color: darkslategray;
  font-size: 1.25rem;
  font-weight: 300;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.card_text {
  flex: 1 1 auto;
  font-size: 1rem;
  line-height: 1.5;

  margin-bottom: 1.25rem;
}
</style> 